// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"7a8800e6","453":"3cfb69a6","518":"49b8566f"}[chunkId] + ".chunk.js";
};